import type {
	BoundActions,
	HookActionsFunction,
	HookFunction,
	StoreActionApi,
} from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

export type EditSourceState = {
	editSource: string;
};

export const initialEditSourceState: EditSourceState = {
	editSource: '',
};
const Store = createStore({
	initialState: {
		...initialEditSourceState,
	},
	actions: {
		setEditSource:
			(
				editSource: string,
			): (({
				setState,
			}: StoreActionApi<{
				editSource: string;
			}>) => void) =>
			({ setState }) => {
				setState({
					editSource,
				});
			},
	},
	name: 'setEditSource',
});

export const useEditSource: HookFunction<
	{
		editSource: string;
	},
	BoundActions<
		{
			editSource: string;
		},
		{
			setEditSource: (editSource: string) => ({
				setState,
			}: StoreActionApi<{
				editSource: string;
			}>) => void;
		}
	>,
	void
> = createHook(Store);
export const useEditSourceActions: HookActionsFunction<
	BoundActions<
		{
			editSource: string;
		},
		{
			setEditSource: (editSource: string) => ({
				setState,
			}: StoreActionApi<{
				editSource: string;
			}>) => void;
		}
	>
> = createActionsHook(Store);
